import { get } from "../methods";
import { removeLeadingSlash } from "../utils";
function getNews_default(lookupValue, headers = {}) {
  return get({
    url: `api/news/${removeLeadingSlash(lookupValue)}`,
    payload: {
      version: "2.0",
      "simplywall.st": true
    },
    headers
  });
}
export {
  getNews_default as default
};
